// src/auth/tokens.js
import { Auth } from "aws-amplify";

export async function getIdTokenJwt() {
    try {
        const session = await Auth.currentSession({ bypassCache: false }); // auto-refreshes if needed
        return session.getIdToken().getJwtToken();
    } catch (error) {
        console.error("Failed to get ID token:", error);
        throw error;
    }
}

export async function getAccessTokenJwt() {
    try {
        const session = await Auth.currentSession({ bypassCache: false }); // auto-refreshes if needed
        return session.getAccessToken().getJwtToken();
    } catch (error) {
        console.error("Failed to get access token:", error);
        throw error;
    }
}
